export default function AccessDenied() {
  const language = navigator.language.startsWith('fr') ? 'fr' : 'en';

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#2b2b2b',
        color: '#80daff',
        backgroundImage:
          "url('https://skyjs-public-global-files.s3.ca-central-1.amazonaws.com/7d4d8f19-77aa-4c3a-882c-48650c2cb153')",
        backgroundPosition: '50% 50%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          height: '100%',
          width: '800px'
        }}
      >
        <DAZZMLogo />
        {language === 'en' ? <EnglishContent /> : <FrenchContent />}
      </div>
    </div>
  );
}

function EnglishContent() {
  return (
    <>
      <h1 style={{ textAlign: 'center' }}>Access Limited</h1>
      <h2 style={{ textAlign: 'center' }}>
        We apologize for the inconvenience, but access to this application is currently restricted
        based on the existing access policy.
      </h2>
      <h2 style={{ textAlign: 'center' }}>
        For assistance in resolving this matter, please consult with your organization&apos;s IT
        support or system administrator.
      </h2>
    </>
  );
}

function FrenchContent() {
  return (
    <>
      <h1 style={{ textAlign: 'center' }}>Accès Limité</h1>
      <h2 style={{ textAlign: 'center' }}>
        Nous nous excusons pour le désagrément, mais l&apos;accès à cette application est
        actuellement restreint en fonction de la politique d&apos;accès en vigueur.
      </h2>
      <h2 style={{ textAlign: 'center' }}>
        Pour obtenir de l&apos;aide afin de résoudre ce problème, veuillez consulter le support
        informatique ou l&apos;administrateur système de votre organisation.
      </h2>
    </>
  );
}

function DAZZMLogo() {
  return (
    <svg
      id="dazzm_logo_app"
      style={{ width: '300px', marginBottom: '40px' }}
      viewBox="0 0 2877.78 572.51"
    >
      <path
        style={{ fill: '#ffffff' }}
        d="M391.98,34.73C355.58,11.58,311.44,0,259.54,0H0V572.51H259.54c52.41,0,96.68-11.45,132.82-34.35,36.13-22.9,63.61-55.72,82.44-98.47,18.82-42.75,28.25-93.89,28.25-153.43s-9.42-109.92-28.25-152.67c-18.83-42.75-46.44-75.69-82.82-98.85Zm-37.02,353.05c-8.66,25.45-22.65,44.03-41.98,55.73-19.34,11.71-45.55,17.56-78.62,17.56H127.48V111.45h107.63c33.07,0,59.16,5.72,78.24,17.17,19.08,11.45,32.94,29.77,41.6,54.96,8.65,25.19,12.98,59.16,12.98,101.91s-4.33,76.85-12.98,102.29Z"
      />
      <path
        style={{ fill: '#ffffff' }}
        d="M734.34,0l-206.1,572.51h135.87l37.5-113.74h208.47l36.47,113.74h138.93L881.66,0h-147.32Zm0,359.54l68.71-208.39h8.4l66.82,208.39h-143.93Z"
      />
      <polygon
        style={{ fill: '#ffffff' }}
        points="2681.6 0 2578.55 414.5 2570.16 414.5 2466.34 0 2270.16 0 2270.16 572.51 2396.11 572.51 2396.11 147.33 2404.51 147.33 2516.72 572.51 2631.99 572.51 2744.2 147.33 2752.59 147.33 2752.59 572.51 2877.78 572.51 2877.78 0 2681.6 0"
      />
      <polygon
        style={{ fill: '#ffffff' }}
        points="1410.92 0 1164.09 0 1164.09 109.92 1312.96 109.92 1410.92 0"
      />
      <polygon
        style={{ fill: '#ffffff' }}
        points="1431.41 323.88 1619.81 109.92 1619.81 0 1558.57 0 1454.16 117.15 1454.16 117.56 1149.59 462.59 1149.59 572.51 1209.17 572.51 1431.03 323.55 1431.41 323.88"
      />
      <polygon
        style={{ fill: '#ffffff' }}
        points="1356.81 572.51 1626.68 572.51 1626.68 462.59 1454.78 462.59 1356.81 572.51"
      />
      <polygon
        style={{ fill: '#ffffff' }}
        points="1962.17 0 1714.45 0 1714.45 109.92 1864.21 109.92 1962.17 0"
      />
      <polygon
        style={{ fill: '#ffffff' }}
        points="2170.17 109.92 2170.17 0 2109.82 0 1949.33 180.08 1699.95 462.59 1699.95 572.51 1760.42 572.51 1963.74 344.36 2170.17 109.92"
      />
      <polygon
        style={{ fill: '#ffffff' }}
        points="1908.06 572.51 2177.04 572.51 2177.04 462.59 2006.03 462.59 1908.06 572.51"
      />
    </svg>
  );
}
